<template>
  <main>
    <div class="relative w-full lg:h-[70vh] h-[30vh]">
      <!-- Background Image -->
      <div class="absolute inset-0 overflow-hidden">
        <img
          src="../assets/images/HERO Pages ALL 2.png"
          alt="Background"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>

      <!-- Content Wrapper -->
      <div
        class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
      >
        <h2
          class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
        >
          Job Requirement
        </h2>
      </div>

      <!-- SVG Curve (Aligned to Background) -->
      <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
        <path
          fill="#ffffff"
          d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
        ></path>
      </svg>
    </div>

    <!-- Job requirement -->
    <div class="md:px-10 max-w-screen-4xl mx-auto relative z-10 -mt-20">
      <!-- Title Section -->
      <div class="flex items-center lg:ml-40 ml-0 strategic-card">
        <button
          class="bg-yellow text-black text-sm px-6 py-2 font-semibold hover:bg-black hover:text-white"
        >
          Apply now
        </button>
      </div>

      <!-- After apply now implementation -->
      <div
        class="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10 px-6 lg:px-10 py-10"
      >
        <!-- Job Details -->
        <div class="lg:col-span-2">
          <h2 class="text-2xl font-bold">IT SUPPORT</h2>

          <!-- Who Are We Looking For -->
          <h3 class="mt-6 text-lg font-semibold">Who Are We Looking For</h3>
          <ul class="list-disc list-inside space-y-2 mt-2">
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Nullam dictum ligula a gravida porta.</li>
            <li>
              Nam pellentesque orci ut odio blandit, sit amet elementum augue
              venenatis.
            </li>
            <li>
              Vivamus semper magna suscipit leo malesuada, eu dictum velit
              varius.
            </li>
          </ul>

          <!-- What You Will Be Doing -->
          <h3 class="mt-6 text-lg font-semibold">What You Will Be Doing</h3>
          <ul class="list-disc list-inside space-y-2 mt-2">
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Nullam dictum ligula a gravida porta.</li>
            <li>
              Nam pellentesque orci ut odio blandit, sit amet elementum augue
              venenatis.
            </li>
          </ul>

          <!-- Bonus Points -->
          <h3 class="mt-6 text-lg font-semibold">
            Bonus Points for Familiarity with
          </h3>
          <ul class="list-disc list-inside space-y-2 mt-2">
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Nullam dictum ligula a gravida porta.</li>
          </ul>

          <!-- Salary -->
          <h3 class="mt-6 text-lg font-semibold">Salary</h3>
          <ul class="list-disc list-inside space-y-2 mt-2">
            <li>
              <strong>Salary:</strong> N270,000 to N450,000 (Depends on Skill
              and Experience)
            </li>
            <li><strong>Salary Review:</strong> Yearly</li>
          </ul>

          <!-- Educational Requirement -->
          <h3 class="mt-6 text-lg font-semibold">Educational Requirement</h3>
          <p class="mt-2">
            Contrary to popular belief, Lorem Ipsum is not simply random text.
            It has roots in a piece of classical Latin literature from 45 BC,
            making it over 2000 years old...
          </p>
        </div>

        <!-- Job Summary Sidebar -->
        <div class="bg-gray-100 p-6 rounded-lg shadow-md">
          <div class="flex justify-center">
            <router-link
              to="/career/job-requirement/application-form"
              @click="scrollToTop"
              class="bg-yellow text-black font-semibold px-6 py-2 rounded-md w-full text-center hover:bg-yellow-600"
              >Apply Now</router-link
            >
          </div>
          <h4 class="text-lg font-semibold mt-6">Job Summary</h4>
          <div class="space-y-4 mt-4 text-gray-600">
            <div class="flex items-center gap-2">
              <i class="bi bi-briefcase-fill text-xl text-gray-400"></i>
              <p>
                Job Type <br />
                <span class="text-black">Full Time</span>
              </p>
            </div>
            <div class="flex items-center gap-2">
              <i class="bi bi-geo-alt-fill text-xl text-gray-400"></i>
              <p>
                Location <br />
                <span class="text-black">South Breeze Center, Banani 11</span>
              </p>
            </div>
            <div class="flex items-center gap-2">
              <i class="bi bi-calendar-check-fill text-xl text-gray-400"></i>
              <p>
                Date Posted <br />
                <span class="text-black">1 month ago</span>
              </p>
            </div>
            <div class="flex items-center gap-2">
              <i class="bi bi-clock-fill text-xl text-gray-400"></i>
              <p>
                Experience <br />
                <span class="text-black">1-3 years</span>
              </p>
            </div>
            <div class="flex items-center gap-2">
              <i class="bi bi-clock-history text-xl text-gray-400"></i>
              <p>
                Working Hours <br />
                <span class="text-black">9 AM - 6 PM</span>
              </p>
            </div>
            <div class="flex items-center gap-2">
              <i class="bi bi-calendar-fill text-xl text-gray-400"></i>
              <p>
                Working Days <br />
                <span class="text-black">Weekly: 5 days</span>
              </p>
            </div>
            <div class="flex items-center gap-2">
              <i class="bi bi-person-fill text-xl text-gray-400"></i>
              <p>
                Vacancy <br />
                <span class="text-black">3</span>
              </p>
            </div>
          </div>
          <router-link
            to="/career"
            @click="scrollToTop"
            class="text-yellow underline block mt-4"
            >View all jobs</router-link
          >
        </div>
      </div>

      <div class="row py-10">
          <div class="card border-none">
            <img
              src="../assets/images/working-at-home.png"
              alt="Team Work"
              class="img-fluid rounded-lg h-96 w-full object-cover"
            />
          </div>
        </div>
    </div>
  </main>
</template>

<script>
export default {
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      {
        threshold: 0.2, // Adjust for smoother animation trigger
      }
    );

    document
      .querySelectorAll(".strategic-card")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.who-style {
  font-family: Montserrat;
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}

.fade-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}
.fade-section.fade-in {
  opacity: 1;
  transform: translateY(0);
}
</style>
